import http from '@/base/api/public'

let apiUrl = require('@/../config/sysConfig')

// 契約明細検索检索
export const c_0002 = (params,dataSource) => {
  if (dataSource == '1') {
    return http.requestQuickGet(apiUrl.apiUrl_ContractDetail + '?recNo=' + params.recNo)
  } else if (dataSource == '2') {
    return http.requestQuickGet(apiUrl.apiUrl_ContractDetailNew + '?recNo=' + params.recNo)
  } else {
    return http.requestQuickGet(apiUrl.apiUrl_ContractDetail + '?recNo=' + params.recNo)
  }
}
// 契約確認情報保存
export const c_0002_save = (params,dataSource) => {
  if (dataSource == '1') {
    return http.requestPost(apiUrl.apiUrl_ContractStatus, params)
  } else if (dataSource == '2') {
    return http.requestPost(apiUrl.apiUrl_ContractStatusNew, params)
  } else {
    return http.requestPost(apiUrl.apiUrl_ContractStatus, params)
  }
}
//PDF查询
export const PDFFile_get = (PDFPath) => {
  return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(PDFPath) + '&resizeCd=0')
}


// WEBPACK FOOTER //
// ./src/module/api/c_0002.js